import LinearScaleRoundedIcon from "@mui/icons-material/LinearScaleRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import PrecisionManufacturingRoundedIcon from "@mui/icons-material/PrecisionManufacturingRounded";
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useEditorStore } from "@/features/scene-editor/editor-store";
import { MAX_OBJECTS_PER_KIND, type ObjectKind } from "@/features/simulation/public";

/**
 * オブジェクト配置パレット。
 *
 * クリックで該当 kind の placement モードに入る → マップ上のタイルをクリックで配置。
 * 各 kind の現在数 / 上限を表示。上限到達時はボタン無効化。
 */

const ITEMS: { kind: ObjectKind; label: string; Icon: typeof LinearScaleRoundedIcon }[] = [
  { kind: "conveyor", label: "コンベア", Icon: LinearScaleRoundedIcon },
  { kind: "press", label: "プレス機", Icon: PrecisionManufacturingRoundedIcon },
  { kind: "arm", label: "アーム", Icon: SmartToyRoundedIcon },
  { kind: "transport", label: "搬送ロボ", Icon: LocalShippingRoundedIcon },
  { kind: "sensor", label: "センサー", Icon: SensorsRoundedIcon },
];

export function PalettePanel() {
  const draft = useEditorStore((s) => s.draft);
  const placement = useEditorStore((s) => s.placement);
  const setPlacement = useEditorStore((s) => s.setPlacement);

  const counts: Record<ObjectKind, number> = {
    conveyor: draft.conveyors.length,
    press: draft.presses.length,
    arm: draft.arms.length,
    transport: draft.transports.length,
    sensor: draft.sensors.length,
  };

  return (
    <Stack sx={{ p: 2, gap: 1, borderRight: "1px solid", borderColor: "divider", width: 200 }}>
      <Typography variant="caption" sx={{ fontWeight: 700 }}>
        オブジェクト配置
      </Typography>
      {ITEMS.map(({ kind, label, Icon }) => {
        const count = counts[kind];
        const max = MAX_OBJECTS_PER_KIND[kind];
        const atLimit = count >= max;
        const active = placement === kind;
        return (
          <Button
            key={kind}
            size="small"
            variant={active ? "contained" : "outlined"}
            color={active ? "primary" : "inherit"}
            startIcon={<Icon fontSize="small" />}
            onClick={() => setPlacement(active ? null : kind)}
            disabled={atLimit}
            sx={{ justifyContent: "flex-start", textTransform: "none" }}
          >
            <Box sx={{ flex: 1, textAlign: "left" }}>
              {label}
              <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                {count}/{max}
              </Typography>
            </Box>
          </Button>
        );
      })}
      {placement && (
        <Typography variant="caption" color="primary" sx={{ mt: 1 }}>
          配置モード: マップ上のタイルをクリック
        </Typography>
      )}
    </Stack>
  );
}
